import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  TextField,
} from '@mui/material';
import { IAttribute, IAttributeValue } from './constants';

interface Props {
  attribute: IAttribute;
  data?: IAttributeValue;
  isLoading?: boolean;
  onSubmit: (payload: Partial<IAttributeValue>) => void;
  onClose: () => void;
}

// Create / edit form for an attribute option (attribute_values row).
export const AttributeValueForm: FC<Props> = ({
  attribute,
  data,
  isLoading,
  onSubmit,
  onClose,
}) => {
  const [name, setName] = useState(data?.name ?? '');
  const [slug, setSlug] = useState(data?.slug ?? '');
  const [order, setOrder] = useState<string>(String(data?.order ?? 0));
  const [touched, setTouched] = useState(false);

  const submit = () => {
    setTouched(true);
    if (!name.trim()) return;
    onSubmit({
      name: name.trim(),
      slug: slug.trim() || undefined,
      order: Number(order) || 0,
    });
  };

  return (
    <Dialog open fullWidth maxWidth="xs" onClose={onClose}>
      <DialogTitle>
        <Typography fontFamily="CircularStdBlack" sx={{ fontSize: 20 }}>
          {data ? 'Edit' : 'Add'} Option
        </Typography>
        <Typography color="var(--text-2)" sx={{ fontSize: 13 }}>
          {attribute.name}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box className="flex flex-col gap-4 pt-2">
          <TextField
            label="Name"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
            error={touched && !name.trim()}
            helperText={touched && !name.trim() ? 'Name is required' : ''}
            fullWidth
          />
          <TextField
            label="Slug"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            helperText="Optional — generated from the name when left blank"
            fullWidth
          />
          <TextField
            label="Order"
            type="number"
            value={order}
            onChange={(e) => setOrder(e.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1.5 }}>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={submit} disabled={isLoading}>
          {isLoading ? 'Saving…' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
